<template>
  <div class="report">
    <div class="report_header">
      <a-space>
        <div @click="swapClass" class="class_name">
          {{ classIndex > -1 ? classList[classIndex].class_name : "" }}
        </div>
        <a-icon @click="swapClass" type="swap"></a-icon>
      </a-space>
      <a-space>
        <a-button
          @click="handleSchoolSemesterReport"
          type="danger"
          ghost
          icon="read"
          >学校报告</a-button
        >
        <a-button @click="handleSemesterReport" icon="file-text"
          >学期报告</a-button
        >
        <a-select
          style="width:200px"
          v-model="form.semester_id"
          @change="changeSemester"
        >
          <a-select-option
            v-for="(item, index) in semesterList"
            :key="index"
            placeholder="选择学期"
            :value="item.sm_id"
            >{{ item.name }}</a-select-option
          >
        </a-select>
      </a-space>

      <!-- <div class="year">2024-2025学期</div> -->
    </div>

    <div :key="monthsKeys" class="months">
      <a-collapse
        accordion
        @change="changeMonth"
        :default-active-key="0"
        :bordered="false"
      >
        <template #expandIcon="props">
          <a-icon type="caret-right" :rotate="props.isActive ? 90 : 0" />
        </template>
        <a-collapse-panel
          v-for="(month, index) in data"
          :key="index"
          :header="month.tite"
          :bordered="false"
        >
          <div class="student-list">
            <div @click="handleShowClassReport(month)" class="item">
              <img src="../../../assets/class-report.png" alt="" />
              <div class="name">班级报告</div>
            </div>
            <div
              v-for="(student, index) in studentList"
              @click="handleShowStuReport(student)"
              :key="index"
              class="item"
            >
              <img src="../../../assets/stu_avatar2.png" alt="" />
              <div class="name">{{ student.student_name }}</div>
            </div>
          </div>
          <!-- <a-empty v-if="studentList.length == 0"></a-empty> -->
        </a-collapse-panel>
      </a-collapse>
    </div>
    <a-drawer
      width="800px"
      :get-container="false"
      placement="right"
      title="班级报告详情"
      :visible="showReport"
      @close="showReport = false"
    >
      <div v-if="reportDetail" class="report-detail class">
        <div class="header">
          <img class="back" src="../../../assets/report_class.jpg" alt="" />
          <div class="msg">
            <div class="school">
              {{ reportDetail.school_name || "学校名称" }}
            </div>
            <div class="title">{{ reportDetail.title }}</div>
            <div class="class_name">{{ reportDetail.class_name }}</div>
          </div>
        </div>
        <div class="content">
          <div class="report_info">
            <div class="info_head">
              <div class="info_title">本月全班数据</div>

              <div class="info_list">
                <div class="item">
                  <div class="number">{{ reportDetail.target.length }}</div>
                  <div class="label">表现行为数</div>
                </div>
                <div class="item">
                  <div class="number">{{ reportDetail.record_student }}</div>
                  <div class="label">记录幼儿数</div>
                </div>
                <div class="item">
                  <div class="number">
                    {{ reportDetail.total_record + reportDetail.total_notable }}
                  </div>
                  <div class="label">成长记录数</div>
                </div>
              </div>
            </div>
            <div class="info_foot">
              <div class="top_name">报告说明</div>
              <div class="tips">
                本报告是根据《幼儿园教育指导纲要》和《3-6岁儿童学习与发展指引》为指导，报告目的在于对课程实施的反馈、调节和改善
              </div>
            </div>
          </div>

          <section class="report-item">
            <div class="title">
              本月班级表现行为记录次数领域分布
            </div>
            <div id="field" class="echart"></div>
          </section>

          <section class="report-item">
            <div class="title">
              本月班级表现行为记录次数领域分布
            </div>
            <div id="fieldLevel" class="echart"></div>
          </section>

          <!-- <section class="report-item">
            <div class="title">
              本月班级表现行为记录次数领域分布
            </div>
            <div id="fieldCount" class="echart"></div>
          </section> -->

          <section class="report-item">
            <div class="title">
              本月班级表现行为记录次数领域分布
            </div>
            <div class="table-box">
              <table class="table">
                <thead class="table-head">
                  <th>排名</th>
                  <th>表现行为</th>
                  <th>发布次数</th>
                  <th>获得幼儿数</th>
                </thead>
                <tbody class="table-body">
                  <tr
                    v-if="showMorefield || index < 6"
                    v-for="(item, index) in reportDetail.target"
                    :key="index"
                  >
                    <td>{{ index + 1 }}</td>
                    <td>{{ item.target_name }}</td>
                    <td>{{ item.total_count }}</td>
                    <td>{{ item.student_count }}</td>
                  </tr>
                </tbody>
              </table>
              <div
                v-if="!showMorefield"
                @click="showMorefield = true"
                class="more"
              >
                展开更多>>>
              </div>
            </div>
          </section>

          <section class="report-item">
            <div class="title">
              本月幼儿数据情况
            </div>
            <div class="table-box">
              <table class="table">
                <thead class="table-head">
                  <th>姓名</th>
                  <th>表现行为数</th>
                  <th>成长记录数</th>
                </thead>
                <tbody class="table-body">
                  <tr
                    v-if="showMoreStudent || index < 6"
                    v-for="(item, index) in reportDetail.students"
                    :key="index"
                  >
                    <td>{{ item.student_name }}</td>
                    <td>{{ item.target3_count }}</td>
                    <td>{{ item.record_count }}</td>
                  </tr>
                </tbody>
              </table>
              <div
                v-if="!showMoreStudent"
                @click="showMoreStudent = true"
                class="more"
              >
                展开更多>>>
              </div>
            </div>
          </section>
        </div>
      </div>
    </a-drawer>
    <!--学期报告详情-->
    <a-drawer
      width="800px"
      :get-container="false"
      placement="right"
      title="学期报告详情"
      :visible="showSemesterReport"
      @close="showSemesterReport = false"
    >
      <div v-if="semesterReportDetail" class="report-detail class">
        <div class="header content-sys">
          <img
            class="back"
            style="width: 100%;"
            src="../../../assets/sysback.png"
            alt=""
          />
          <div class="msg">
            <div class="school">
              {{ semesterReportDetail.school_name || "学校名称" }}
            </div>
            <div class="title">
              {{ semesterReportDetail.class_name + "发展报告" }}
            </div>
            <div class="class_name">
              {{ semesterReportDetail.semester_name }}
            </div>
          </div>
        </div>
        <div class="content " style="margin-top: -40px;">
          <div class="report_info">
            <div class="info_head">
              <div class="info_title">报告说明</div>

              <div class="panel">
                <div class="panel-cell">
                  <div class="label">评估对象：</div>
                  <div class="info">
                    {{
                      semesterReportDetail.class_name +
                        " 共" +
                        semesterReportDetail.students.length +
                        "名幼儿"
                    }}
                  </div>
                </div>
                <div class="panel-cell">
                  <div class="label">评估周期：</div>
                  <div class="info">
                    {{ semesterReportDetail.semester_date }}
                  </div>
                </div>
                <div class="panel-cell">
                  <div class="label">评估参考标准：</div>
                  <div class="info">
                    本报告是根据《幼儿园教育指导纲要》和《3-6岁儿童学习与发展指南》为指导
                    ，以"课程评价促进发展"的理念，报告目的在于对课程实施的反馈、调节与改善。
                  </div>
                </div>
              </div>
            </div>
          </div>

          <section class="report-item">
            <div class="title">
              本班幼儿各领域发展水平
            </div>
            <div
              id="sysStuLevel"
              style="width: 100%;height: 300px;"
              class="echart"
            ></div>
          </section>

          <section class="report-item">
            <div class="title">
              本月幼儿各领域表现行为分布
            </div>
            <section class="sys-chart">
              <div class="level-cell">
                <div class="level-name">1.健康领域</div>
                <div class="echart">
                  <div id="sysField1"></div>
                </div>
              </div>
              <div class="level-cell">
                <div class="level-name">2.语言领域</div>
                <div class="echart">
                  <div id="sysField2"></div>
                </div>
              </div>
              <div class="level-cell">
                <div class="level-name">3.科学领域</div>
                <div class="echart">
                  <div id="sysField3"></div>
                </div>
              </div>
              <div class="level-cell">
                <div class="level-name">4.社会领域</div>
                <div class="echart">
                  <div id="sysField4"></div>
                </div>
              </div>
              <div class="level-cell">
                <div class="level-name">5.艺术领域</div>
                <div class="echart">
                  <div id="sysField5"></div>
                </div>
              </div>
            </section>
          </section>
          <!--学生领域数量统计-->
          <section class="report-item">
            <div class="sys-chart">
              <div class="labels">
                <div
                  v-for="(item, index) in colorLabels"
                  :key="index"
                  class="item"
                >
                  <div
                    class="color"
                    :style="{ backgroundColor: item.color }"
                  ></div>
                  <div class="name">{{ item.name }}</div>
                </div>
              </div>

              <div class="stu-content" style="padding: 20px;">
                <div class="stuhead">
                  <div class="tr">
                    <div class="td name">姓名</div>
                    <div class="td">健康领域</div>
                    <div class="td">语言领域</div>
                    <div class="td">科学领域</div>
                    <div class="td">社会领域</div>
                    <div class="td">艺术领域</div>
                  </div>
                </div>
                <div class="stubody">
                  <div
                    v-for="(item, index) in semesterReportDetail.students"
                    :key="index"
                    class="tr"
                  >
                    <div
                      @click="handleStudentLevelReport(item)"
                      class="td name"
                      style="cursor: pointer;"
                    >
                      {{ item.student_name }}
                    </div>
                    <div
                      v-for="(item2, index2) in item.studentItems"
                      :key="index2"
                      class="td"
                    >
                      <div class="tags" :class="item2.color"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </a-drawer>

    <!--学校学期报告详情-->
    <a-drawer
      width="800px"
      :get-container="false"
      placement="right"
      title="学校学期报告详情"
      :visible="showSchoolReport"
      @close="showSchoolReport = false"
    >
      <div v-if="schoolReportDetail" class="report-detail class">
        <div class="header">
          <img class="back" src="../../../assets/report_class.jpg" alt="" />
          <div class="msg">
            <div class="school">
              {{ schoolReportDetail.school_name || "学校名称" }}
            </div>
            <div class="title" style="font-size: 22px;">
              {{ schoolReportDetail.semester_name + "发展报告" }}
            </div>
            <div
              class="class_name"
              style="font-weight: bold;font-size: 18px;color: #555;"
            >
              {{ schoolReportDetail.semester_date }}
            </div>
          </div>
        </div>
        <div class="content ">
          <div class="report_info">
            <div class="info_head">
              <div class="info_title">报告说明</div>

              <div class="panel">
                <div class="panel-cell">
                  <div class="label">评估对象：</div>
                  <div class="info">
                    {{
                      schoolReportDetail.classObserStatices
                        .map((item) => item.class_name)
                        .join("、")
                    }}
                  </div>
                </div>
                <div class="panel-cell">
                  <div class="label">评估周期：</div>
                  <div class="info">
                    {{ schoolReportDetail.semester_date }}
                  </div>
                </div>
                <div class="panel-cell">
                  <div class="label">评估参考标准：</div>
                  <div class="info">
                    本报告是根据《幼儿园教育指导纲要》和《3-6岁儿童学习与发展指南》为指导
                    ，以"课程评价促进发展"的理念，报告目的在于对课程实施的反馈、调节与改善。
                  </div>
                </div>
              </div>
            </div>
          </div>

          <section class="report-item">
            <div class="title">
              各班幼儿各领域发展水平
            </div>
            <div class="sys-chart" style="padding-top: 0;">
              <div class="chart-title">
                各班幼儿各领域评估概览
              </div>
              <div
                id="schoolChart1"
                style="width: 100%;height: 300px;margin: 10px 0;"
                class="echart"
              ></div>
            </div>
          </section>

          <section
            v-for="(item, index) in schoolReportDetail.classObserStatices"
            :key="index"
            class="report-item"
          >
            <div class="sys-chart" style="padding-top: 0;">
              <div class="chart-title">
                {{ item.class_name }}幼儿各领域发展水平分布统计
              </div>
              <div
                :id="'schoolFieldChart' + index"
                style="width: 100%;height: 300px;margin: 10px 0;"
                class="echart"
              ></div>
            </div>
          </section>
        </div>
      </div>
    </a-drawer>

    <a-drawer
      width="800px"
      placement="right"
      title="学生阶段发展评估报告"
      :visible="showStudentLevelReport"
      @close="showStudentLevelReport = false"
    >
      <div class="report-detail levelStudent">
        <div class="header">
          <!-- <img class="back" src="../../../assets/report_stu.jpg" alt="" /> -->
          <div class="msg">
            <div class="avatar-box">
              <img class="avatar" style="width: 80px;" src="../../../assets/report-avatar.png" alt="">
              
            </div>
            <div class="title">{{ studentLevelReportDetail.student_name || '' }}</div>
            <div class="time">阶段发展评估报告：{{ studentLevelReportDetail.semester_date || '' }}</div>
          </div>
        </div>

        <div class="repory-content">
          <div class="report_info">
            <div class="info_head">
              <div class="info_title">报告说明</div>

              <div class="panel">
                <div class="panel-cell">
                  <div class="label">评估对象：</div>
                  <div class="info">
                    {{ studentLevelReportDetail.school_name + ' ' + studentLevelReportDetail.class_name + ' '  + studentLevelReportDetail.student_name || '' }}
                  </div>
                </div>
                <div class="panel-cell">
                  <div class="label">评估周期：</div>
                  <div class="info">
                    {{ studentLevelReportDetail.semester_date || '' }}
                  </div>
                </div>
                <div class="panel-cell">
                  <div class="label">评估参考标准：</div>
                  <div class="info">
                    本报告是根据《幼儿园教育指导纲要》和《3-6岁儿童学习与发展指南》为指导
                    ，以"课程评价促进发展"的理念，报告目的在于对课程实施的反馈、调节与改善。
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="mubiao-list">
            <div v-for="(item,index) in studentLevelReportDetail.records" :key="index" class="mubiao-cell">
              <div class="label">{{ (index + 1) + '.' + item.target3_name }}</div>
              <div class="field">{{item.field_name + '>' + item.target2_name}}</div>
              <div class="info">{{item.target5_name}}</div>
            </div>
          </div>
        </div>
		
		<div class="student-report-remark">
		  <div class="title">评语</div>
		  <div class="remark">{{studentLevelReportDetail.remark || '暂无评语'}}</div>
		  <!-- <a-input-search placeholder="在此输入评论" v-model="pushRemark" @search="handlePushRemark">
		    <a-button slot="enterButton">
		      发布
		    </a-button>
		  </a-input-search> -->
		</div>
      </div>
    </a-drawer>

    <a-drawer
      width="800px"
      placement="right"
      title="学生报告详情"
      :visible="showStuReport"
      @close="showStuReport = false"
    >
      <div v-if="reportStuDetail" class="report-detail student">
        <div class="header">
          <!-- <img class="back" src="../../../assets/report_stu.jpg" alt="" /> -->
          <div class="msg">
            <div class="avatar-box">
              <!-- <img class="avatar" src="../../../assets/stu_avatar2.png" alt=""> -->
              <div class="name">{{ reportStuDetail.student_name }}</div>
            </div>
            <div class="title">{{ reportStuDetail.title }}</div>
            <div class="school">
              {{ reportStuDetail.school_name || "学校名称" }}
            </div>

            <div class="class_name">{{ reportStuDetail.class_name }}</div>
          </div>
        </div>

        <div class="history">
          <div class="title">
            {{ reportStuDetail.student_name }}本月成长表现记录
          </div>
          <div class="list">
            <div
              v-if="index < 5"
              v-for="(item, index) in reportStuDetail.items"
              :key="index"
              class="item"
            >
              {{ item.target_name }}
            </div>
          </div>
        </div>

        <div class="record" style="padding-bottom:30px">
          <div class="title">
            {{ reportStuDetail.student_name }}本月成长记录
          </div>
          <div class="record-list">
            <observe-list
              v-model="observeListData"
              :isExport="exportState"
              ref="observeList"
            ></observe-list>
          </div>
        </div>
      </div>
    </a-drawer>
    <a-modal
      :visible="showClassList"
      width="780px"
      @cancel="showClassList = false"
      :bodyStyle="{ padding: '10px 20px' }"
      @ok="handleChangeClass"
      title="选择班级"
      centered
    >
      <a-radio-group name="radioGroup" v-model="classIndex">
        <a-radio
          :style="radioStyle"
          v-for="(classItem, index) in classList"
          :key="index"
          :value="index"
        >
          {{ classItem.class_name }}
        </a-radio>
      </a-radio-group>
    </a-modal>
  </div>
</template>

<script>
import { mapState } from "vuex";
import {
  reportApi,
  leaderApi as directorTestApi,
} from "../../../api/api-director";
import qs from "qs";
import * as XLSX from "xlsx";
import axios from "axios";
import * as echarts from "echarts";
import observeList from "@/components/leader/report-list.vue";
import { max } from "lodash";

export default {
  name: "reportClass",
  data() {
    return {
      observeListForm: {
        act_id: "",
        currentPage: 1,
        etime: "",
        name: "",
        pageSize: 5,
        type: "",
        stime: "",
        data_type: "official",
        leader_id: "",
        student_id: "",
      },
      colorLabels: [
        {
          color: "#D2D2D2",
          name: "未观察到表现行为",
        },
        {
          color: "#FF7A7A",
          name: "表现行为1",
        },
        {
          color: "#FFE389",
          name: "表现行为2",
        },
        {
          color: "#C2EBA7",
          name: "表现行为3",
        },
      ],
      showSemesterReport: false,
      showMoreStudent: false,
      showMorefield: false,
      showMoreRecord: false,
      observeListData: [],
      exportState: false, // 导出状态
      loadMore: "loading", // 加载状态
      activeMonth: 0,
      semesterList: [],
      msg: "Hello World!",
      search: "", // 搜索关键字
      searchDate: null, // 时间段
      data: [], // 表格数据
      showReport: false, // 显示报告
      monthsKeys: 0,
      form: {
        class_id: "", // 班级id
        pageSize: 10,
        currentPage: 1,
        school_id: "", // 学校id
        semester_id: "",
        // testfield_id:""
      },
      classList: [],
      classIndex: -1,
      studentList: [],
      resetForm: {
        // 重置表单
        class_id: "", // 班级id
        pageSize: 10,
        currentPage: 1,
        school_id: "", // 学校id
      },
      showClassList: false,
      radioStyle: {
        display: "block",
        height: "30px",
        lineHeight: "30px",
      },
      reportDetail: null,
      reportStuDetail: null,
      showStuReport: false,
      semesterReportDetail: null,
      showSchoolReport: false,
      schoolReportDetail: null,
      showStudentLevelReport: false,
      studentLevelReportDetail: {
        student_name: "",
        class_name: "",
        school_name: "",
        title: "",
        items: [],
      },
    };
  },
  created() {
    if (this.userInfo) {
      this.form.school_id = this.school.id; // 设置学校id
      this.resetForm.school_id = this.school.id; // 设置学校id
      this.getClassList(); // 获取班级列表
    }
  },
  components: {
    observeList,
  },
  computed: {
    ...mapState(["headers", "userInfo", "school"]),
  },
  watch: {
    school(newVal, oldVal) {
      this.form.school_id = newVal.id; // 设置学校id
      this.resetForm.school_id = newVal.id; // 设置学校id
      this.getClassList(); // 获取班级列表
    },
  },
  methods: {
    handleStudentLevelReport(student) {
      this.$message.loading({
        content: "读取中...",
        key: "loading",
        duration: 0,
      }); // 显示加载中

      this.$axios({
        method: "post",
        url: reportApi.main + reportApi.getSchoolClassReportStudentDetail,
        headers: {
          "content-type": "application/x-www-form-urlencoded",
          Authorization: this.$store.state.headers,
        },
        data: qs.stringify({
          semester_id: this.form.semester_id,
          class_id: this.form.class_id,
          school_id: this.form.school_id,
          student_id: student.student_id,
        }),
      })
        .then((res) => {
          if (res.data.result && res.data.data) {
            this.studentLevelReportDetail = res.data.data;
            this.studentLevelReportDetail.semester_date = res.data.data.start_time.substr(0, 10) + '~' + res.data.data.end_time.substr(0, 10);
            this.$message.destroy("loading"); // 关闭加载中
            this.showStudentLevelReport = true;

          } else {
            this.$message.destroy("loading"); // 关闭加载中
            this.$message.error(res.data.message); // 显示错误信息
            this.studentLevelReportDetail = null;
          }
        })
        .catch((err) => {
          console.log(err);
          this.$message.destroy("loading"); // 关闭加载中
          this.$message.error("读取失败"); // 显示错误信息
        });
    },
    initialSemesterReportEcharts() {
      const semesterDom = document.getElementById("sysStuLevel");

      const semesterReportEcharts = echarts.init(semesterDom);
      console.log(this.classList, this.semesterReportDetail);
      const class_name = this.semesterReportDetail.class_name;
      const opt = {
        legend: {
          data: ["年级平均", class_name],
        },
        //缩小图表
        grid: {
          top: "15%",
          left: "5%",
          right: "5%",
          bottom: "15%",
        },

        radar: {
          shape: "circle",
          indicator: this.semesterReportDetail.item.map((item) => ({
            name: item.field_name,
          })),
          radius: "60%",
        },
        series: [
          {
            name: "Budget vs spending",
            type: "radar",
            data: [
              {
                value: this.semesterReportDetail.gradeItem.map((item) => {
                  return item.avg_target3_count
                }),
                label: {
                  show: true,
                  formatter: function(params) {
                    return params.value;
                  },
                },
                name: "年级平均",
              },
              {
                value: this.semesterReportDetail.item.map((item) => {
                  return item.or_count1 + item.or_count2 + item.or_count3;
                }),
                label: {
                  show: true,
                  formatter: function(params) {
                    return params.value;
                  },
                },
                name: class_name,
              },
            ],
          },
        ],
      };

      semesterReportEcharts.setOption(opt);

      this.renderFieldEcharts(
        "sysField1",
        this.semesterReportDetail.item.find(
          (item) => item.field_name == "健康领域"
        )
      );
      this.renderFieldEcharts(
        "sysField2",
        this.semesterReportDetail.item.find(
          (item) => item.field_name == "语言领域"
        )
      );
      this.renderFieldEcharts(
        "sysField3",
        this.semesterReportDetail.item.find(
          (item) => item.field_name == "科学领域"
        )
      );
      this.renderFieldEcharts(
        "sysField4",
        this.semesterReportDetail.item.find(
          (item) => item.field_name == "社会领域"
        )
      );
      this.renderFieldEcharts(
        "sysField5",
        this.semesterReportDetail.item.find(
          (item) => item.field_name == "艺术领域"
        )
      );
    },
    renderFieldEcharts(id, fieldItem) {
      console.log(id, fieldItem);
      const dom = document.getElementById(id);
      const chart = echarts.init(dom);
      console.log(fieldItem);
      //五大领域图
      const series = ["未发现到阶梯一", "阶梯一", "阶梯二", "阶梯三"].map(
        (name) => {
          if (name == "未发现到阶梯一") {
            return {
              name,
              type: "bar",
              stack: "total",
              barWidth: "60",
              itemStyle: {
                color: "#D2D2D2",
              },
              data: fieldItem.target2.map((item) => item.count_1),
            };
          }

          if (name == "阶梯一") {
            return {
              name,
              type: "bar",
              stack: "total",
              barWidth: "60",
              itemStyle: {
                color: "#C2EBA7",
              },
              data: fieldItem.target2.map((item) => item.count_2),
            };
          }

          if (name == "阶梯二") {
            return {
              name,
              type: "bar",
              stack: "total",
              barWidth: "60",
              itemStyle: {
                color: "#FFe389",
              },
              data: fieldItem.target2.map((item) => item.count_3),
            };
          }

          if (name == "阶梯三") {
            return {
              name,
              type: "bar",
              stack: "total",
              barWidth: "60",
              itemStyle: {
                color: "#80d998",
              },
              //计算百分比
              data: fieldItem.target2.map((item) => item.count_4),
            };
          }
        }
      );
      const option = {
        legend: {
          selectedMode: false,
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
          formatter: function(params) {
            console.log(params);
            return params[0].name + "<br>" + params.map((item) => item.seriesName + ": " + item.value + "%").join("<br>");
          },
        },
        yAxis: {
          type: "value",
          minInterval: 1,
          max: 100,
          //后缀
          axisLabel: {
            formatter: "{value} %",
          },
        },
        xAxis: {
          type: "category",
          data: fieldItem.target2.map((item) => item.target_name),
        },
        series,
      };
      chart.setOption(option);
    },
    initSchoolReportEcharts() {
      const schoolDom = document.getElementById("schoolChart1");
      const schoolReportEcharts = echarts.init(schoolDom);

      const option = {
        legend: {
          data: this.schoolReportDetail.classObserStatices.map(
            (item) => item.class_name
          ),
        },
        radar: {
          // shape: 'circle',
          indicator: this.schoolReportDetail.classObserStatices[0].item.map(
            (item) => ({
              name: item.field_name,
            })
          ),
          radius: "80%",
          // 位置
          center: ["50%", "60%"],
        },
        series: [
          {
            name: "Budget vs spending",
            type: "radar",
            data: this.schoolReportDetail.classObserStatices.map((item) => ({
              value: item.item.map(
                (item2) => item2.or_count1 + item2.or_count2 + item2.or_count3
              ),
              name: item.class_name,
            })),
          },
        ],
      };

      schoolReportEcharts.setOption(option);
      this.$nextTick(() => {
        this.schoolReportDetail.classObserStatices.forEach((item, index) => {
          this.setSchoolCharts(index);
        });
      });
    },
    //求三个数的百分比，兼容三个0
    getPercent(a, b, c) {
      if (a + b + c == 0) {
        return 33.33;
      }
      return ((a / (a + b + c)) * 100).toFixed(2);
    },
    setSchoolCharts(index) {
      const dom = document.getElementById(`schoolFieldChart${index}`);
      const schoolReportEcharts = echarts.init(dom);

      const option2 = {
        tooltip: {
          trigger: "axis",
          formatter: function(params) {
            let result = params[0].axisValue + "<br/>";
            params.forEach((item) => {
              result +=
                item.marker + item.seriesName + ": " + item.value + "%<br/>";
            });
            return result;
          },
        },
        legend: {},
        grid: {
          top: "12%",
          left: "5%",
          right: "5%",
          bottom: "5%",
          containLabel: true,
        },
        xAxis: {
          type: "value",
          axisLabel: {
            formatter: "{value} %", // 显示数值和单位
          },
          //放到上方
          position: "top",
          max: 100,
          minInterval: 20,
        },
        yAxis: {
          type: "category",
          data: this.schoolReportDetail.classObserStatices[index].item.map(
            (item) => item.field_name
          ), // 使用数据中的 name 作为 yAxis 的数据
          //字号12，加粗
          axisLabel: {
            fontSize: 12, // 设置字号为12
            fontWeight: "bold", // 设置字体加粗
          },
          //去掉y轴黑线
          axisLine: {
            show: false, // 设置轴线不显示
          },
          //去掉y轴刻度
          axisTick: {
            show: false, // 设置刻度不显示
          },
        },
        series: [
          {
            name: "阶梯1",
            type: "bar",
            stack: "total",
            itemStyle: {
              color: "#dae9d2",
            },
            emphasis: {
              focus: "series",
            },
            data: this.schoolReportDetail.classObserStatices[index].item.map(
              (item) => {
                return this.getPercent(
                  item.or_count1,
                  item.or_count2,
                  item.or_count3
                );
              }
            ), // 使用数据中的 value 作为 series 的数据
          },
          {
            name: "阶梯2",
            type: "bar",
            stack: "total",
            itemStyle: {
              color: "#fcd495",
            },
            emphasis: {
              focus: "series",
            },
            data: this.schoolReportDetail.classObserStatices[index].item.map(
              (item) => {
                return this.getPercent(
                  item.or_count2,
                  item.or_count1,
                  item.or_count3
                );
              }
            ), // 使用数据中的 value 作为 series 的数据
          },
          {
            name: "阶梯3",
            stack: "total",
            type: "bar",
            itemStyle: {
              color: "#c4eafa",
            },
            emphasis: {
              focus: "series",
            },
            data: this.schoolReportDetail.classObserStatices[index].item.map(
              (item) => {
                return this.getPercent(
                  item.or_count3,
                  item.or_count1,
                  item.or_count2
                );
              }
            ), // 使用数据中的 value 作为 series 的数据
          },
        ],
      };

      schoolReportEcharts.setOption(option2);
    },
    //学校学期报告
    handleSchoolSemesterReport() {
      this.$message.loading({
        content: "读取中...",
        key: "loading",
        duration: 0,
      }); // 显示加载中

      this.$axios({
        method: "post",
        url: reportApi.main + reportApi.getSchoolReportDetail,
        headers: {
          "content-type": "application/x-www-form-urlencoded",
          Authorization: this.$store.state.headers,
        },
        data: qs.stringify({
          ...this.form,
        }),
      })
        .then((res) => {
          if (res.data.result && res.data.data) {
            this.schoolReportDetail = res.data.data;
            this.$message.destroy("loading"); // 关闭加载中

            setTimeout(() => {
              this.showSchoolReport = true;
              if (this.schoolReportDetail.classObserStatices.length) {
                this.initSchoolReportEcharts();
              }
            }, 30);
          } else {
            this.$message.destroy("loading"); // 关闭加载中
            this.$message.error(res.data.message); // 显示错误信息
            this.schoolReportDetail = null;
          }
        })
        .catch((err) => {
          console.log(err);
          this.$message.destroy("loading"); // 关闭加载中
          this.$message.error("读取失败"); // 显示错误信息
        });
    },

    //学期报告
    handleSemesterReport() {
      this.$message.loading({
        content: "读取中...",
        key: "loading",
        duration: 0,
      }); // 显示加载中
      this.$axios({
        method: "post",
        url: reportApi.main + reportApi.getSemesterReportDetail,
        headers: {
          "content-type": "application/x-www-form-urlencoded",
          Authorization: this.$store.state.headers,
        },
        data: qs.stringify({
          ...this.form,
        }),
      })
        .then((res) => {
          if (res.data.result && res.data.data) {
            this.semesterReportDetail = res.data.data;
            console.log(this.semesterReportDetail,'111111');
            this.semesterReportDetail.students.forEach((item) => {
              item.studentItems.forEach((item2) => {
                item2.color = item2.or_count3
                  ? "color3"
                  : item2.or_count2
                  ? "color2"
                  : item2.or_count2
                  ? "color1"
                  : "";
              });

              //按照参数field_name 健康领域 语言领域 科学领域   社会领域 艺术领域排序
              const arr = [];
              arr.push(
                item.studentItems.find((item) => item.field_name == "健康领域")
              );
              arr.push(
                item.studentItems.find((item) => item.field_name == "语言领域")
              );
              arr.push(
                item.studentItems.find((item) => item.field_name == "科学领域")
              );
              arr.push(
                item.studentItems.find((item) => item.field_name == "社会领域")
              );
              arr.push(
                item.studentItems.find((item) => item.field_name == "艺术领域")
              );
              if (item.studentItems.length != 0) {
                item.studentItems = arr;
              } else {
                item.studentItems = [];
              }
            });
            setTimeout(() => {
              this.showSemesterReport = true;
              this.initialSemesterReportEcharts();
              console.log(this.semesterReportDetail);
              this.$message.destroy("loading"); // 关闭加载中
            }, 20);
          } else {
            this.$message.destroy("loading"); // 关闭加载中
            this.$message.error(res.data.message); // 显示错误信息
            this.semesterReportDetail = null;
          }
        })
        .catch((err) => {
          console.log(err);
          this.$message.destroy("loading"); // 关闭加载中
          this.$message.error("读取失败"); // 显示错误信息
        });
    },
    getObserveList(more) {
      this.observeListForm.school_id = this.school.id || "";
      this.observeListForm.class_id =
        this.classList[this.classIndex].class_id || "";
      this.observeListForm.student_id = this.reportStuDetail.student_id || "";
      this.observeListForm.leader_id = this.userInfo.id || "";
      this.observeListForm.stime = this.reportStuDetail.start_time || ""; // 设置开始时间
      this.observeListForm.etime = this.reportStuDetail.end_time || ""; // 设置结束时间

      if (more) {
        this.observeListForm.pageSize = 100; // 重置当前页为1
      } else {
        this.observeListForm.pageSize = 6;
      }
      axios({
        method: "post",
        url: directorTestApi.main + directorTestApi.getObserRecordList,
        headers: {
          "content-type": "application/x-www-form-urlencoded",
          Authorization: this.$store.state.headers,
        },
        data: qs.stringify({
          ...this.observeListForm,
          sid: this.$store.state.headers,
        }),
      })
        .then((res) => {
          this.$message.destroy("loading"); // 关闭加载中

          if (res.data.result) {
            this.observeListData = res.data.data;
          } else {
            this.observeListData = [];
          }

          this.showStuReport = true; // 显示报告
          this.$forceUpdate(); // 强制更新
        })
        .catch((e) => {
          this.$message.error("网络服务错误");
        });
    },
    numbersToPercentages(arr) {
      const [num1, num2, num3] = arr;
      const sum = num1 + num2 + num3;
      if (sum === 0) {
        return [0, 0, 0];
      }
      console.log(num1, num2, num3, arr, "arrrrrr");
      const percent1 = ((num1 / sum) * 100).toFixed(0);
      const percent2 = ((num2 / sum) * 100).toFixed(0);
      const percent3 = ((num3 / sum) * 100).toFixed(0);
      console.log(percent1, percent2, percent3);
      return [percent1, percent2, percent3];
    },
    initClassEcharts() {
      const fieldDom = document.getElementById("field"); // 获取echarts容器
      const myChart = echarts.init(fieldDom); // 初始化echarts
      const myChart2 = echarts.init(document.getElementById("fieldLevel")); // 初始化echarts
      // const myChart3 = echarts.init(document.getElementById("fieldCount")); // 初始化echarts
      const option = {
        tooltip: {
          trigger: "axis",
        },
        // legend: {},
        grid: {
          top: "5%",
          left: "5%",
          right: "5%",
          bottom: "5%",
          containLabel: true,
        },
        xAxis: {
          type: "value",
          axisLabel: {
            formatter: "{value} 次", // 显示数值和单位
          },
          //放到上方
          minInterval: 1,
          position: "top",
        },
        yAxis: {
          type: "category",
          data: this.reportDetail.item.map((item) => item.field_name), // 使用数据中的 name 作为 yAxis 的数据
          //字号12，加粗
          axisLabel: {
            fontSize: 12, // 设置字号为12
            fontWeight: "bold", // 设置字体加粗
          },
          //去掉y轴黑线
          axisLine: {
            show: false, // 设置轴线不显示
          },
          //去掉y轴刻度
          axisTick: {
            show: false, // 设置刻度不显示
          },
        },
        series: [
          {
            name: "领域表现次数",
            type: "bar",
            itemStyle: {
              color: "#c4eafa",
            },
            data: this.reportDetail.item.map((item) => item.target3_count), // 使用数据中的 value 作为 series 的数据
          },
        ],
      };

      const option2 = {
        tooltip: {
          trigger: "axis",
          formatter: function(params) {
            let result = params[0].axisValue + "<br/>";
            params.forEach((item) => {
              result +=
                item.marker + item.seriesName + ": " + item.value + "%<br/>";
            });
            return result;
          },
        },
        legend: {},
        grid: {
          top: "12%",
          left: "5%",
          right: "5%",
          bottom: "5%",
          containLabel: true,
        },
        xAxis: {
          type: "value",
          axisLabel: {
            formatter: "{value} %", // 显示数值和单位
          },
          //放到上方
          position: "top",
          max: 100,
          minInterval: 20,
        },
        yAxis: {
          type: "category",
          data: this.reportDetail.item.map((item) => item.field_name), // 使用数据中的 name 作为 yAxis 的数据
          //字号12，加粗
          axisLabel: {
            fontSize: 12, // 设置字号为12
            fontWeight: "bold", // 设置字体加粗
          },
          //去掉y轴黑线
          axisLine: {
            show: false, // 设置轴线不显示
          },
          //去掉y轴刻度
          axisTick: {
            show: false, // 设置刻度不显示
          },
        },
        series: [
          {
            name: "阶梯1",
            type: "bar",
            stack: "total",
            itemStyle: {
              color: "#dae9d2",
            },
            emphasis: {
              focus: "series",
            },
            data: this.reportDetail.item.map((item) => item.level1), // 使用数据中的 value 作为 series 的数据
          },
          {
            name: "阶梯2",
            type: "bar",
            stack: "total",
            itemStyle: {
              color: "#fcd495",
            },
            emphasis: {
              focus: "series",
            },
            data: this.reportDetail.item.map((item) => item.level2), // 使用数据中的 value 作为 series 的数据
          },
          {
            name: "阶梯3",
            stack: "total",
            type: "bar",
            itemStyle: {
              color: "#c4eafa",
            },
            emphasis: {
              focus: "series",
            },
            data: this.reportDetail.item.map((item) => item.level3), // 使用数据中的 value 作为 series 的数据
          },
        ],
      };

      myChart.setOption(option); // 设置echarts选项
      myChart2.setOption(option2); // 设置echarts选项
    },
    handleShowStuReport(student) {
      this.$message.loading({ content: "读取中...", key: "loading" }); // 显示加载中
      this.$axios({
        method: "post",
        url: reportApi.main + reportApi.getStudentReportDetail,
        headers: {
          "content-type": "application/x-www-form-urlencoded",
          Authorization: this.$store.state.headers,
        },
        data: qs.stringify({
          id: student.id,
        }),
      }).then((res) => {
        if (res.data.result) {
          this.$nextTick(() => {
            this.reportStuDetail = res.data.data; // 设置报告详情
            setTimeout(() => {
              this.getObserveList();
            }, 200);
          });
        }
      });
    },
    changeMonth(key, activeKeys) {
      console.log(key, activeKeys); // 打印当前展开的面板和所有展开的面板的 key 数组
      if (key) {
        this.activeMonth = key; // 设置月份index
        this.getAllStudents(); // 获取学生列表
        this.$forceUpdate();
      }
    },
    changeSemester() {
      this.getMonths(); // 获取月份列表
    },
    handleChangeClass() {
      this.showClassList = false; // 关闭弹窗
      this.form.class_id = this.classList[this.classIndex].id; // 设置班级id
      this.resetForm.class_id = this.classList[this.classIndex].id; // 设置班级id
      this.getMonths();
    },
    handleShowClassReport(month) {
      console.log(month); // 打印月份
      this.$message.loading({ content: "读取中...", key: "loading" }); // 显示加载中
      this.$axios({
        method: "post",
        url: reportApi.main + reportApi.getClassReportList,
        headers: {
          "content-type": "application/x-www-form-urlencoded",
          Authorization: this.$store.state.headers,
        },
        data: qs.stringify({
          ...this.form,
          month: month.month, // 设置月份
          semester_id: month.semester_id, // 设置学期id
          school_id: this.school.id || "",
          ym: month.ym, // 设置年月
        }),
      })
        .then((res) => {
          if (res.data.result && res.data.data.length > 0) {
            const id = res.data.data[0].id; // 获取id
            this.$axios({
              method: "post",
              url: reportApi.main + reportApi.getClassReportDetail,
              headers: {
                "content-type": "application/x-www-form-urlencoded",
                Authorization: this.$store.state.headers,
              },
              data: qs.stringify({
                id, // 设置id
              }),
            }).then((res) => {
              if (res.data.result) {
                this.$message.destroy("loading"); // 关闭加载中
                this.$nextTick(() => {
                  this.reportDetail = res.data.data; // 设置报告详情
                  this.reportDetail.item = this.reportDetail.item.map(
                    (item) => {
                      item.level1 = this.numbersToPercentages([
                        item.or_count1,
                        item.or_count2,
                        item.or_count3,
                      ])[0]; // 设置阶梯1
                      item.level2 = this.numbersToPercentages([
                        item.or_count1,
                        item.or_count2,
                        item.or_count3,
                      ])[1]; // 设置阶梯2
                      item.level3 = this.numbersToPercentages([
                        item.or_count1,
                        item.or_count2,
                        item.or_count3,
                      ])[2]; // 设置阶梯3
                      console.log(item.level1, item.level2, item.level3); // 打印阶梯1、2、3
                      return { ...item }; // 设置字段名称
                    }
                  );
                  this.showReport = true; // 显示报告
                  this.showMoreStudent = false;
                  this.$nextTick(() => {
                    this.initClassEcharts(); // 初始化echarts
                  });
                });
              } else {
                this.$message.destroy("loading"); // 关闭加载中
                this.$message.error(res.data.message); // 显示错误信息
              }
            });
          } else {
            this.$message.destroy("loading"); // 关闭加载中
            this.$message.error(res.data.message); // 显示错误信息
          }
        })
        .catch((err) => {
          this.$message.destroy("loading"); // 关闭加载中
          this.$message.error("读取失败"); // 显示错误信息
        });
    },
    swapClass() {
      this.showClassList = !this.showClassList;
    },
    getSemesterList() {
      this.$axios({
        method: "post",
        url: reportApi.main + reportApi.getSemesterList,
        headers: {
          "content-type": "application/x-www-form-urlencoded",
          Authorization: this.$store.state.headers,
        },
        data: qs.stringify({
          currentPage: 1,
          pageSize: 100,
        }),
      }).then((res) => {
        console.log(res); // 打印ap
        if (res.data.result) {
          this.semesterList = res.data.data;
          console.log(this.semesterList); // 打印api retur
          const current = this.semesterList.find((item) => item.is_current); // 查找当前学期
          this.form.semester_id = current.sm_id; // 设置学期id
          this.resetForm.semester_id = current.sm_id; // 设置学期id
          this.getMonths();
        }
      });
    },
    getMonths() {
      this.$axios({
        method: "post",
        url: reportApi.main + reportApi.getSemesterMonthList,
        headers: {
          "content-type": "application/x-www-form-urlencoded",
          Authorization: this.$store.state.headers,
        },
        data: qs.stringify({
          ...this.form,
          sid: this.$store.state.headers,
        }),
      }).then((res) => {
        if (res.data.result) {
          this.data = res.data.data;
          this.activeMonth = 0; // 设置月份index
          this.monthsKeys++;
          this.getAllStudents(); // 获取学生列表
          this.$forceUpdate();
        }
      });
    },
    getClassList() {
      const form = {
        currentPage: 1,
        pageSize: 300,
        leader_id: this.userInfo.id,
        sid: this.$store.state.headers,
        school_id: this.school.id || "",
      };
      axios({
        method: "post",
        url: directorTestApi.main + directorTestApi.allClassList,
        headers: {
          "content-type": "application/x-www-form-urlencoded",
          Authorization: this.$store.state.headers,
        },
        data: qs.stringify(form),
      }).then((res) => {
        if (res.data.result) {
          this.classList = res.data.data;
          if (this.classList.length > 0) {
            this.form.class_id = this.classList[0].id; // 设置班级id
            this.resetForm.class_id = this.classList[0].id; // 设置班级id
            this.getSemesterList(); // 获取学期列表
            this.classIndex = 0; // 设置班级index
          } else {
            this.form.class_id = ""; // 设置班级id
            this.resetForm.class_id = ""; // 设置班级id
            this.studentList = []; // 设置学生列表为空
            this.classIndex = -1; // 设置班级index为-1
          }
        }
      });
    },
    getAllStudents() {
      this.$message.loading({ content: "读取中...", key: "loading" }); // 显示加载中
      console.log(this.data, this.activeMonth); // 打印表单数据
      this.studentListForm = {
        class_id: this.form.class_id, // 设置班级id,
        currentPage: 1,
        name: "",
        pageSize: 100,
        school_id: this.school.id || "",
        ym: this.data[this.activeMonth].ym,
        semester_id: this.form.semester_id,
      };

      const ym = this.data[this.activeMonth].ym; // 获取年月
      axios({
        method: "post",
        url: reportApi.main + reportApi.getStudentReportList,
        headers: {
          "content-type": "application/x-www-form-urlencoded",
          Authorization: this.$store.state.headers,
        },
        data: qs.stringify({
          ...this.studentListForm,
          sid: this.$store.state.headers,
        }),
      }).then((res) => {
        this.$message.destroy("loading"); // 关闭加载中
        if (res.data.result) {
          if (ym == this.data[this.activeMonth].ym) {
            this.studentList = res.data.data;
          }
        } else {
          this.studentList = []; // 设置学生列表为空
        }
      });
    },
    pageChange() {},
  },
};
</script>

<style lang="less" scoped>
.chart-title {
  font-size: 16px;
  font-weight: bold;
  color: #fff;
  padding: 10px 50px;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  background: #66b0dd;
  display: inline-block;
  white-space: nowrap;
  margin-left: 50%;
  transform: translateX(-50%);
}
.student-report-remark {
  .title {
    font-weight: bold;
    font-size: 16px;
    padding:10px 0;
  }
  
  .remark {
	  padding: 10px;
	  background: #f3f3f3;
	  border-radius: 6px;
	  margin-bottom: 10px;
  }
  
}
#field {
  width: 100%;
  height: 300px;
  background: #fff !important;
  border-radius: 6px;
}

#fieldLevel {
  width: 100%;
  height: 300px;
  background: #fff !important;
  border-radius: 6px;
}

#sysStuLevel {
  width: 100%;
  height: 300px;
  background: #fff !important;
  border-radius: 6px;
  padding-top: 10px;
}

#fieldCount {
  width: 100%;
  height: 300px;
  background: #fff !important;
  border-radius: 6px;
}

.labels {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  .item {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    margin: 0 10px;
    .color {
      width: 26px;
      height: 14px;
      border-radius: 3px;
      margin-right: 6px;
    }

    .name {
      line-height: 16px;
      color: #555;
      font-size: 12px;
    }
  }
}

.stuhead {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  background: #c8edeb;
  padding: 8px 0;
  font-size: 14px;
  .tr {
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    text-align: center;
    .td {
      width: 80px;
      font-size: 12px;
      text-align: center;
    }
  }
}

.stubody {
  width: 100%;
  .tr {
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    text-align: center;
    justify-content: flex-start;
    .td {
      width: 80px;
      text-align: center;
      padding: 10px 2px;
      font-size: 12px;

      .tags {
        background: #d2d2d2;
        width: 100%;
        height: 16px;
      }

      .color1 {
        background: #ff7a7a;
      }

      .color2 {
        background: #ffe389;
      }

      .color3 {
        background: #c2eba7;
      }
    }

    .name {
      background: #ecfbf9;
    }
  }
}

#sysField1 {
  width: 100%;
  height: 300px;
}

#sysField2 {
  width: 100%;
  height: 300px;
}

#sysField3 {
  width: 100%;
  height: 300px;
}

#sysField4 {
  width: 100%;
  height: 300px;
}

#sysField5 {
  width: 100%;
  height: 300px;
}

.report-item {
  .more {
    text-align: center;
    color: #66aedb;
    font-size: 12px;
    background: #ebf6fc;
    cursor: pointer;
    width: 100%;
    display: block;
    padding: 6px 0;
    margin-top: -1px;
  }
  .table-box {
    width: 100%;
    border-radius: 6px;
    overflow: hidden;
  }
  .table {
    width: 100%;
    border-collapse: collapse;
    overflow: hidden;
    .table-head {
      background-color: #ebf6fc;
      font-weight: bold;
      text-align: center;

      th {
        padding: 10px;
        border-right: 1px solid #f3f3f3;
        &:last-child {
          border-right: none;
        }
      }
    }

    tbody {
      text-align: center;

      tr {
        background: #fff;
        td {
          padding: 10px;
          border-right: 1px solid #f3f3f3;
          &:last-child {
            border-right: none;
          }
          &:first-child {
            background: #e5f8f7;
          }
        }
      }
    }
  }
}

.report-item {
  width: 100%;
  margin-top: 10px;

  .title {
    font-size: 14px;
    font-weight: bold;
    color: #585858;
    padding: 10px 20px;
    text-align: center;
  }
}

.report_header {
  width: 100%;
  height: 60px;
  padding: 20px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;

  .class_name {
    font-size: 20px;
    font-weight: bold;
    color: #333;
    cursor: pointer;
  }

  .year {
    color: #999;
  }
}

.report_info {
  border-radius: 12px;
  overflow: hidden;
  .info_head {
    width: 100%;
    background: #fff;
    padding-bottom: 10px;
    box-sizing: border-box;

    .info_title {
      font-size: 16px;
      font-weight: bold;
      color: #333;
      padding: 10px 20px;
      text-align: center;
    }

    .info_list {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;

      .item {
        flex: 1;
        display: flex;
        flex-direction: column;
        align-items: center;

        .number {
          font-size: 24px;
          font-weight: bold;
          color: #67b0db;
        }

        .label {
          font-size: 14px;
          color: #666;
        }
      }
    }
  }

  .info_foot {
    width: 100%;
    height: 100px;
    background: #dbebeb;
    margin-top: 5px;
    padding: 10px 20px;

    .top_name {
      font-size: 14px;
      font-weight: bold;
      color: #666;
      margin-bottom: 4px;
    }

    .tips {
      font-size: 14px;
      color: #666;
    }
  }
}

.report-detail {
  width: 100%;
  background: #fff;

  .header {
    width: 100%;
    padding-top: 20px;
    z-index: 10;
    box-sizing: border-box;
    position: relative;

    .back {
      width: 80%;
      display: block;
      overflow: hidden;
      margin: 0 auto;
    }

    .msg {
      width: 100%;
      text-align: center;
      font-size: 20px;
      position: absolute;
      top: 40px;

      .school {
        font-size: 14px;
        color: #8a8a8a;
        font-weight: bold;
      }

      .title {
        font-size: 20px;
        color: #65afdc;
        font-weight: bold;
        margin: 6px 0;
      }

      .class_name {
        font-size: 12px;
        color: #555;
      }
    }
  }

  &.levelStudent {
    
    .msg {
      position: static;
      margin-bottom: 20px;

      .time {
        font-size: 14px;
        color: #8a8a8a;
      }
    }

    .repory-content {
      background: #c3e7f9;
      border-radius: 6px;
      padding: 10px;
      .mubiao-list {
        width: 100%;
        border-radius: 6px;
        overflow: hidden;
        margin-top: 10px;
        box-sizing: border-box;
        .mubiao-cell {
          width: 100%;
          padding: 15px 20px;
          border-bottom: 1px solid #f3f3f3;
          background: #fff;
          margin-bottom: 10px;
          border-radius: 5px;
          &:last-child {
            border-bottom: none;
          }
          .label {
            font-size: 16px;
            color: #65afdc;
            font-weight: bold;
          }
          .field {
            font-size: 14px;
            color: #666;
          }
          .info {
            font-size: 14px;
            color: #666;
            margin-top: 4px;
            line-height: 20px;
          }
        }
      }
    }

    .info_foot {
    width: 100%;
    height: 100px;
    background: #fff;
    margin-top: 5px;
    padding: 10px 20px;
    border-radius: 5px;

    .top_name {
      font-size: 14px;
      font-weight: bold;
      color: #666;
      margin-bottom: 4px;
    }

    .tips {
      font-size: 14px;
      color: #666;
    }
  }
  }

  .content {
    width: 100%;
    background: #c4e7fa;
    padding: 30px 20px;
    box-sizing: border-box;
    border-radius: 12px;
    margin-top: 15px;
  }
}

.report-detail.student {
  position: relative;
  background-image: url("../../../assets/report_stu.jpg");
  background-size: 40% auto;
  background-position: center top;
  background-repeat: no-repeat;

  .header {
    overflow: hidden;
    padding-top: 0;
  }

  .msg {
    top: 30px;
    margin-top: 130px;
    position: static;

    .avatar {
      width: 60px;
      height: 60px;
      border: 7px solid #4c8b9c;
      border-radius: 100%;
      background: #fff;
      z-index: 1;
    }

    .title {
      color: #67aeda;
    }

    .name {
      width: 100px;
      // background: #fcd388;
      font-size: 18px;
      color: #333;
      font-weight: bold;
      padding: 3px 10px;
      border-radius: 100px;
      margin: 0px auto 0;
      z-index: 10;
    }
  }

  .record {
    padding: 10px 20px;
    z-index: 100;
    padding-top: 30px;
    background: #c4e7fa;
    border-bottom-left-radius: 12px;
    border-bottom-right-radius: 12px;

    .title {
      font-size: 16px;
      color: #585858;
      font-weight: bold;
      margin-bottom: 10px;
      text-align: center;
    }
  }

  .history {
    padding: 10px 20px;
    z-index: 100;
    margin-top: 50px;
    background: #c4e7fa;
    border-top-left-radius: 12px;
    border-top-right-radius: 12px;

    .title {
      font-size: 16px;
      color: #585858;
      font-weight: bold;
      margin-bottom: 10px;
      text-align: center;
    }

    .list {
      background: #fff;
      border-radius: 4px;
      padding: 10px;
      display: flex;
      box-shadow: 0 2px 6px 1px rgba(0, 0, 0, 0.1);
      flex-direction: column;
      align-items: center;

      .item {
        margin: 2px 0;
      }
    }
  }
}
.panel {
  width: 100%;
  .panel-cell {
    width: 100%;
    padding: 2px 20px;
    .label {
      font-size: 14px;
      color: #444;
      display: inline;
      font-weight: bold;
    }
    .info {
      font-size: 14px;
      color: #666;
      display: inline;
    }
  }
}
.report-detail .content-sys {
  padding: 20px;
  .msg {
    text-align: left;
    .school {
      font-size: 16px;
    }
    .class_name {
      font-size: 16px;
      font-weight: bold;
    }
  }
}

.student-list {
  display: flex;
  flex-wrap: wrap;
  .item {
    width: 16.6666%;
    padding: 20px 0;
    background: #f5f5f5;
    border-radius: 5px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    cursor: pointer;

    img {
      width: 55px;
      height: 55px;
      margin-bottom: 10px;
      border-radius: 10px;
    }

    .name {
      font-size: 14px;
      color: #333;
    }
  }
}
.report {
  background: #fff;
  border-radius: 5px;
  margin-top: 10px;
  height: calc(100vh - 90px);
  width: 860px;
}

.months {
  height: calc(100% - 60px);
  overflow-y: auto;
}
.level-cell {
  width: 100%;
  .level-name {
    width: 160px;
    font-size: 16px;
    color: #585858;
    font-weight: bold;
    margin-bottom: 10px;
    text-align: center;
    background: #d9f0ee;
    border-top-right-radius: 20px;
    border-bottom-right-radius: 20px;
    padding: 8px 8px 8px 0;
  }
}
.sys-chart {
  background: #fff;
  padding: 20px 0;
  border-radius: 5px;
}
</style>
